var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"account-item"},[_c('div',{staticClass:"account-item__head"},[_c('h3',{staticClass:"account-item__title"},[_vm._v(_vm._s(_vm.$t('Змінити пароль')))])]),_c('PasswordEdit',{staticClass:"account-item__content"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }